import { useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Box, Container, Paper, Typography, Alert } from "@mui/material";
import { LoginForm } from "../../components/auth";
import { useAuth } from "../../hooks";
import config from "../../config/environment";
import heightenLogo from "../../assets/images/heighten-logo.png";

const LoginPage = () => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as any)?.from?.pathname || "/";
  const resetSuccess = (location.state as any)?.resetSuccess || false;

  useEffect(() => {
    // If user is already authenticated, check for forced password reset
    if (isAuthenticated) {
      console.log(
        "User authenticated, checking forcePasswordChange:",
        user?.forcePasswordChange,
      );

      // If user needs to reset password, redirect to forced reset page
      if (user?.forcePasswordChange) {
        navigate("/auth/forced-password-reset", { replace: true });
      } else {
        // Otherwise redirect to intended destination
        navigate(from, { replace: true });
      }
    }
  }, [isAuthenticated, user, navigate, from]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#1e293b", // slate-800 to match sidebar
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="xs">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 3 }}>
            <Box
              component={Link}
              to="/"
              sx={{ display: "inline-block", textDecoration: "none" }}
            >
              <Box
                component="img"
                src={heightenLogo}
                alt="Heighten Management"
                sx={{ cursor: "pointer" }}
              />
            </Box>
          </Box>

          {/* Login Card */}
          <Paper elevation={3} sx={{ p: 4, width: "100%" }}>
            <Typography component="h2" variant="h4" align="center" gutterBottom>
              Welcome Back
            </Typography>

            <Typography
              variant="body2"
              align="center"
              color="text.secondary"
              sx={{ mb: 3 }}
            >
              Sign in to your account to continue
            </Typography>

            {resetSuccess && (
              <Alert severity="success" sx={{ mb: 2 }}>
                Password has been reset successfully!
              </Alert>
            )}

            <LoginForm />
          </Paper>

          {/* Footer */}
          <Typography
            variant="caption"
            align="center"
            sx={{ mt: 4, color: "white" }}
          >
            © 2025 {config.app.tagline}. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default LoginPage;
